module.exports = __webpack_public_path__ + "static/media/card-info.1c67471d.png";